import { render } from "./wellness.vue?vue&type=template&id=2342f936&scoped=true"
import script from "./wellness.vue?vue&type=script&lang=js"
export * from "./wellness.vue?vue&type=script&lang=js"

import "./wellness.vue?vue&type=style&index=0&id=2342f936&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2342f936"]])

export default __exports__